import React, { useState } from 'react';
import * as styles from './UserThemeSetting.module.scss';
import useUpdateUserSettings from './useUpdateUserSettings';
import useAppSelector from '../../app/redux/useAppSelector';
import Button from '../../components/Button';
import Form, { Field, FieldSet, Submit } from '../../components/Form';
import SVGIcon from '../../components/SVGIcon';
import Tooltip from '../../components/Tooltip';
import { UiThemeSetting } from '../../graphql/generated/graphql';
import informationIcon from '../../icons/non-prefilled/16x16/information.svg';
import SettingCard from '../../settings/SettingCard';

const OPTIONS: Record<UiThemeSetting, string> = {
  AUTO: 'System preference',
  LIGHT: 'Light theme',
  DARK: 'Dark theme',
};

const TOOLTIPS: Partial<Record<UiThemeSetting, string>> = {
  AUTO: 'Automatically switch\nbetween themes based\non your system settings',
};

const UserThemeSetting = () => {
  const [isEditing, setIsEditing] = useState(false);
  const updateUserSettings = useUpdateUserSettings();
  const theme =
    useAppSelector((state) => state.session.user?.settings?.uiTheme) ||
    UiThemeSetting.Auto;

  const title = (
    <div className={styles.labelContainer}>
      <span>Interface theme</span>
    </div>
  );
  return isEditing ? (
    <SettingCard
      description={
        <Form<{ theme?: UiThemeSetting }>
          initialValues={{ theme }}
          onSubmit={(values) => {
            if (values.theme) {
              updateUserSettings({ uiTheme: values.theme }).then(() =>
                setIsEditing(false),
              );
            }
          }}
        >
          <FieldSet legend={title}>
            {Object.entries(OPTIONS).map(([value, label]) => {
              const tooltip = TOOLTIPS[value as UiThemeSetting];

              return (
                <Field
                  key={value}
                  type="radio"
                  name="theme"
                  value={value}
                  label={
                    <div className={styles.labelContainer}>
                      {label}
                      {tooltip && (
                        <Tooltip placement="right" content={tooltip}>
                          <SVGIcon className={styles.infoIcon}>
                            {informationIcon}
                          </SVGIcon>
                        </Tooltip>
                      )}
                    </div>
                  }
                />
              );
            })}
          </FieldSet>
          <div className={styles.formFooter}>
            <Submit variant="primary">Save</Submit>
          </div>
        </Form>
      }
    />
  ) : (
    <SettingCard
      title={title}
      description={OPTIONS[theme]}
      actions={
        <Button
          variant="secondary"
          onClick={() => {
            setIsEditing(true);
          }}
        >
          Edit
        </Button>
      }
    />
  );
};

export default UserThemeSetting;
